
/*
* 派送司机页面路径枚举
* */
export enum DeliveringPath {
    DELIVERY_DELIVERING="/delivery/delivering",
    DELIVERY_DELIVERING_ORDER="/delivery/delivering/:trackingNumber",
    DELIVERY_MARK_EXCEPTION="/delivery/mark-exception",
    DELIVERY_SCAN_PACKAGE="/delivery/scan-package",
    DELIVERY_MAP_MODE="/delivery/map-mode",
    DELIVERY_CHAT="/delivery/chat",
    DELIVERY_CHAT_LIST="/delivery/chat-list",
    DELIVERY_ADDRESS_COORDINATE_FEEDBACK="/delivery/address-coordinate-feedback/:trackingNumber",
    DELIVERY_ADDRESS_COORDINATE_FEEDBACK_NATIVE="/delivery/address-coordinate-feedback/native/:trackingNumber"
}
/*
* 订单详情/派送页面路径枚举
* */
export enum DeliveryDetailPath {
    DELIVERY_DELIVERING_ORDER_DETAIL="/delivery/delivering/detail/:trackingNumber",
    DELIVERY_DELIVERING_ORDER_DETAIL_ADD_ACCESS_CODE="/delivery/delivering/detail/:trackingNumber/add-access-code",
    DELIVERY_DELIVERING_ORDER_DETAIL_ACCESS_INFO="/delivery/delivering/detail/:trackingNumber/access-info",
    DELIVERY_DELIVERING_ORDER_DETAIL_UPDATE_ACCESS_CODE="/delivery/delivering/detail/:trackingNumber/update-access-code",
}
/*
* 任务列表页面路径枚举
* */
export enum TaskPath {
    DELIVERY_TASK = "/delivery/task",
    DELIVERY_TASK_ASSIGNMENTS="/delivery/task/new-assignments",
    DELIVERY_TASK_ASSIGNMENTS_DETAILS="/delivery/task/new-assignments/details",
    DELIVERY_TASK_TRANSFER_IN="/delivery/task/transfer-in",
    DELIVERY_TASK_TRANSFER_IN_DETAILS="/delivery/task/transfer-in/details",
    DELIVERY_TASK_RETURN="/delivery/task/return",
    DELIVERY_TASK_TRANSFER_OUT="/delivery/task/transfer-out",
    DELIVERY_TASK_AREA_SCAN_DETAIL="/delivery/task/area-scan-detail",
}
/*
* DSP经理列表页面路径枚举
* */
export enum DspPath {
    DELIVERY_DSP_HOME = "/dsp/home",
    DELIVERY_DSP_TASK = "/dsp/task",
    DELIVERY_DSP_OPERATIONAL = "/dsp/operational",
    DELIVERY_DSP_OPERATIONAL_PARTICULARS = "/dsp/operational/particulars/:driverId",
    DELIVERY_DSP_OPERATIONAL_PARTICULARS_DETAIL = "/dsp/operational-data/particulars-detail/:trackingNumber",
    DELIVERY_DSP_OPERATIONAL_PARTICULARS_POD = "/dsp/operational-data/particulars-pod/:trackingNumber",
    DELIVERY_DSP_OPERATIONAL_PARTICULARS_MARK_FAIL = "/dsp/operational-data/particulars-mark-fail/:trackingNumber",
    DELIVERY_DSP_RECEIVING_SORTING_SCAN = "/dsp/home/receiving-sorting/scan",
    DELIVERY_DSP_RECEIVING_SORTING_DETAILS = "/dsp/home/receiving-sorting/details",
    DELIVERY_DSP_RECEIVING_SORTING_NEW_DETAILS = "/dsp/home/receiving-sorting/newDetails",
    DELIVERY_DSP_RECEIVING_SORTING_CONFIRM = "/dsp/home/receiving-sorting/confirm",
    DELIVERY_DSP_RECEIVING_SORTING_SUMMARY = "/dsp/home/receiving-sorting/summary",
    DELIVERY_DSP_PACKAGE_SCAN = "/dsp/home/scan",
    DELIVERY_DSP_TRACK_DETAIL = "/dsp/home/track-detail/:trackingNumber",
    DELIVERY_DSP_DELIVERED_POD = "/dsp/home/delivered-pod/:trackingNumber",
    DELIVERY_DSP_MARK_EXCEPTION = "/dsp/home/mark-exception/:trackingNumber",
    DELIVERY_DSP_DRIVER_VIOLATION_REVIEW = "/dsp/scan/driver-violation-review",
    DELIVERY_DSP_DELIVERY_TASK_DETAILS = "/dsp/delivery-task-details",
    DELIVERY_DSP_DELIVERY_TASK_MAP = "/dsp/delivery-task-map"
}

/*
* 少件提示
* */
export enum IncompletePromptPath {
    DELIVERY_NEW_ASSIGNMENT_START_CONFIRM = "/delivery/task/new-assignments-confirm",
    DELIVERY_TRANSFER_IN_START_CONFIRM = "/delivery/task/transfer-in-confirm",
}

/*
* 用户菜单列表页面路径枚举
* */
export enum UserMenuPath {
    USER_MENU_FAILED = "/delivery/failed",
    USER_MENU_DELIVERED = "/delivery/delivered",
    USER_MENU_IDENTIFICATION = "/delivery/identification",
    USER_MENU_SETTINGS = "/delivery/settings",
    USER_MENU_SETTINGS_LANGUAGE = "/delivery/settings/language",
    USER_MENU_SETTINGS_NAVIGATION_APP = "/delivery/settings/navigation-app",
    USER_MENU_SETTINGS_ROUTE_ENDPOINTS_NATIVE = "/delivery/settings/route-endpoints/native",
    USER_MENU_SETTINGS_ROUTE_ENDPOINTS_MAP_PICKER_NATIVE = "/delivery/settings/route-endpoints/map-picker/native",
}
